<div class="card-header d-flex align-items-center justify-content-between">
    <div id="card-header-wrapper" class="d-flex align-items-center">
        <a
            *ngIf="goBackLink !== ''; else sTitle"
            [routerLink]="goBackLink"
            [relativeTo]="relativeTo"
            [queryParams]="linkQueryParams"
            [fragment]="fragment"
            class="bg-back rounded p-1 text-dark text-decoration-none d-flex align-items-center">
            <i class="fa fa-arrow-left pr-1" aria-hidden="true"></i>
            <h4>{{ title }}</h4>
        </a>
        <ng-template #sTitle>
            <h4>{{ title }}</h4>
        </ng-template>
        <sume-help-tooltip
            *ngIf="tooltipMessage !== ''"
            class="ml-1"
            placement="right"
            [message]="tooltipMessage">
        </sume-help-tooltip>
    </div>
    <div class="d-flex align-items-center justify-content-between">
        <ng-content></ng-content>
        <ng-content select="[buttons]"></ng-content>
    </div>
</div>
